import React, { useState, useEffect } from "react";
import { useStateIfMounted } from "use-state-if-mounted";
import auth from "../core/auth";
import mqtt_topics from "./mqtt_topics";

const Mqtt_statusBar = () => {
  let statment =
    "User " +
    auth.getUserData().username +
    " status on S.& A.S.Co.Ltd IoT SURF network: ";
  const [state, setState] = useStateIfMounted({
    alert: "secondary",
    status: statment + "N/A",
  }); //"S.& A.S.Co.Ltd IoT SURF network connection status: N/A."

  function handlereconnect() {
    setState({
      alert: "success",
      status: statment + "Connected.",
    });
  }
  function handleclose() {
    setState({
      alert: "primary",
      status: statment + "Closed.",
    });
  }
  function handledisconnect() {
    setState({
      alert: "warning",
      status: statment + "Disconnected.",
    });
  }
  function handleoffline() {
    setState({
      alert: "dark",
      status: statment + "Offline.",
    });
  }
  function handleerror() {
    setState({
      alert: "danger",
      status: statment + "Error.",
    });
  }
  function handleend() {
    setState({
      alert: "danger",
      status: statment + "Ended.",
    });
  }
  function handleconnect() {
    setState({
      alert: "success",
      status: statment + "Connected.",
    });
  }

  useEffect(() => {
    let abortController = new AbortController();
    // your async action is here
    let client = mqtt_topics.mqttclientinstance;
    client.on("reconnect", handlereconnect);
    client.on("close", handleclose);
    client.on("disconnect", handledisconnect);
    client.on("offline", handleoffline);
    client.on("error", handleerror);
    client.on("end", handleend);
    client.on("connect", handleconnect);

    return () => {
      abortController.abort();
    };
  }, []);
  useEffect(
    () => () => {
      let client = mqtt_topics.mqttclientinstance;
      client.unsubscribe("reconnect");
      client.removeListener("reconnect", handlereconnect);
      client.unsubscribe("close");
      client.removeListener("close", handleclose);
      client.unsubscribe("disconnect");
      client.removeListener("disconnect", handledisconnect);
      client.unsubscribe("offline");
      client.removeListener("offline", handleoffline);
      client.unsubscribe("error");
      client.removeListener("error", handleerror);
      client.unsubscribe("end");
      client.removeListener("end", handleend);
      client.unsubscribe("connect");
      client.removeListener("connect", handleconnect);
    },
    []
  );
  return (
    <div className={"alert alert-" + state.alert} role="alert">
      {state.status}
      <button
        type="button"
        className="close"
        data-dismiss="alert"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>{" "}
      </button>
    </div>
  );
};
export default Mqtt_statusBar;
